import { render } from "./DbsDetail.vue?vue&type=template&id=419796c4"
import script from "./DbsDetail.vue?vue&type=script&lang=js"
export * from "./DbsDetail.vue?vue&type=script&lang=js"
script.render = render

export default script